export { requestTypeSuggestionEpic } from './epic';
